import { render } from "./Techonlogies.vue?vue&type=template&id=b34215f0&scoped=true"
import script from "./Techonlogies.vue?vue&type=script&lang=js"
export * from "./Techonlogies.vue?vue&type=script&lang=js"

import "./Techonlogies.vue?vue&type=style&index=0&id=b34215f0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b34215f0"]])

export default __exports__